import type { EditorPlugin } from '../../../types/aha-editor';
const BoldMarkPlugin: EditorPlugin = {
  name: 'Bold Mark Plugin',
  mark: {
    type: 'bold',
    props: {
      style: {
        fontWeight: 'bold',
      },
    },
  },
};

export default BoldMarkPlugin;
